import omit from "lodash/omit";

import constants from "general/constants";
import breadcrumbs from "general/components/breadcrumbs";
import general from "general/general";

import "general/components/booking";
import "general/components/footer";
import "general/components/header";
import * as leaflet from "general/components/leafletAssets";

const renderMap = () => {
    let pageData = $("#page-data");
    let instanceName = pageData.data("instance-name");
    let mapBoxAccessToken = pageData.data("map-box-access-token");
    let workplaceData = $("#workplace-data");
    let latitude = parseFloat(workplaceData.data("latitude"));
    let longitude = parseFloat(workplaceData.data("longitude"));
    let coord = [latitude, longitude];
    let map = L.map("gp-profile-map").setView(coord, 17);

    L.tileLayer(
        "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
        {
            attribution:
                'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            tileSize: 512,
            maxZoom: 18,
            zoomOffset: -1,
            id: "mapbox/streets-v11",
            accessToken: mapBoxAccessToken,
        }
    ).addTo(map);

    let icon = L.icon({
        iconAnchor: [12, 34],
        iconUrl: general.getStaticPath(
            `images/${instanceName}/general/marker.png`
        ),
    });
    L.marker(coord, {
        icon: icon,
    }).addTo(map);
};

$(document).ready(function() {
    let activeClass = constants.activeClass,
        clinicMode = $("#clinic-mode").length == 1,
        mapToggle = $(".js-map-toggle"),
        profileMap = $(".js-profile-map");

    // profile - map toggle
    mapToggle.click(function() {
        mapToggle.add(profileMap).toggleClass(activeClass);
        leaflet.assets({ onLoad: () => renderMap()})(document);
    });

    // Breadcrumbs
    breadcrumbs.setup();

    // Appointment Lead form
    let appointmentLeadRoot = document.querySelector(
        ".rm-container-form[form=appointment_lead]",
    );
    if (appointmentLeadRoot) {
        import("components/form").then(function (_form) {
            _form.init({
                container: appointmentLeadRoot,
                form_name: "appointment_lead",
                data: {
                    pr: appointmentLeadRoot.dataset
                        .practitionerId,
                    wo: appointmentLeadRoot.dataset
                        .workplaceId,
                    pn: appointmentLeadRoot.dataset.providerName
                },
                callbacks: {
                    hide: function () {},
                    errors: {
                        showErrorModal: function (message) {
                            general.modalMessage(message, "error");
                        },
                    },
                },
            });
        });
    }

    let profileTabElement = document.querySelector(".js-profile-tab");
    let profileTabContentElement = document.querySelector(".js-profile-tab-content");

    if (profileTabElement) {
        profileTabElement.classList.add("is-active");
    }
    if (profileTabContentElement) {
        profileTabContentElement.classList.add("is-active");
    }
});
